import {withClass} from '../helpers/react-helpers'
import type {ReactNode} from 'react';
import React from 'react'
import cn from 'classnames'
import type {CSSProperties} from 'react'


/**
 * @deprecated Doesn't seem to align the buttons nicely. Consider <FlexButtonBar> instead.
 */
export const ButtonBar = withClass<'div'>('div','button-bar')
// export const FlexButtonBar = styled<'div'>('div','flex-button-bar')


interface FlexButtonBarProps {
    wrap?: true
    noWrap?: true
    children: ReactNode
    marginTop?: CSSProperties['marginTop']
    marginBottom?: CSSProperties['marginBottom']
    gap?: CSSProperties['gap']
}

// export const FlexButtonBar = React.forwardRef<HTMLDivElement,FlexButtonBarProps>(({wrap,noWrap,...props}, ref) => <div ref={ref} className={cn('flex-button-bar',wrap?'wrap':'nowrap')} {...props}/>)

export function FlexButtonBar({wrap,noWrap,marginTop,marginBottom,gap,children}: FlexButtonBarProps) {
    return <div className={cn('flex-button-bar',{wrap,nowrap:noWrap})} style={{marginTop,marginBottom,gap}}>{children}</div>
}


//     (
//     <div ref={ref} className={cn('row-wrapper-outer',className)} {...props}>
//         <div className="row-wrapper-inner">{children}</div>
//     </div>
// ))
